export default __webpack_public_path__ + "static/media/project-default.fd629eee.png";